import { ReactNode } from 'react';
import Flex from '@creditflowresearch/uilib/Flex';

interface IPanelLayoutMobileProps {
  children?: ReactNode,
  className?: string,
  dataTest?: string,
  topContent?: ReactNode,
  headerPanel: ReactNode,
  bottomContent?: ReactNode,
}

const PanelLayoutMobile = ({
  children,
  className,
  dataTest = 'panelLayoutMobile',
  topContent,
  bottomContent,
  headerPanel,
}: IPanelLayoutMobileProps) => {
  return (
    <Flex direction="column" className={ className } dataTest={ dataTest }>
      { headerPanel }
      <Flex direction="column" style={ { marginTop: '10px' } }>
        { topContent }
      </Flex>
      <Flex direction="column">
        { bottomContent }
      </Flex>
      <Flex direction="column">
        { children }
      </Flex>
    </Flex>
  );
};

export default PanelLayoutMobile;
